import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const inviteUserSlice = createSlice({
  name: 'INVITE_USER',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error.message = '';
      state.error.statusCode = null;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetToInitials: (state) => {
      state.isLoading = initialState.isLoading;
      state.success = initialState.success;
      state.error = initialState.error;
    },
  },
});

// REDUCER
export default inviteUserSlice.reducer;

// ACTIONS
export const { loading, success, failure, resetToInitials } = inviteUserSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.invitations.inviteUser.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.invitations.inviteUser.success;
export const selectError = (state: RootState) => state.ui.invitations.inviteUser.error;
